import '../styles/loadingScreen.css';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/navBar';
import { Helmet } from 'react-helmet';
const LoadingScreen = ({ startFadeOut }) => {
  const [isVisible, setIsVisible] = useState(true);
  const lottieLoadFile = process.env.REACT_APP_LOTTIE_LOAD_FILE;

useEffect(() => {
  console.log('LoadingScreen: Rendered, isVisible:', isVisible, 'lottieLoadFile:', lottieLoadFile);
  if (!lottieLoadFile) {
    console.error('LoadingScreen: Lottie file not specified');
    setIsVisible(false); // Hide if no Lottie file
    return;
  }

  if (startFadeOut) {
    console.log('LoadingScreen: Starting fade-out');
    const fadeOutTimer = setTimeout(() => {
      setIsVisible(false);
      console.log('LoadingScreen: Hidden after fade-out');
    }, 1000); // Matches CSS transition
    return () => clearTimeout(fadeOutTimer);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [startFadeOut, lottieLoadFile]);

  return (
    <>
    
    <div className="seo-content">
       <Helmet>
        <meta name="description" content="Mason Ayres Creative is a creative 
agency based in Berks County, Pennsylvania, specializing
 in graphic design, photography, and videography services."
  data-react-helmet="true"/><meta name="keywords" 
  content="graphic design, photography, videography, Berks County,
   Pennsylvania, creative agency, professional services, creative
    consulting, print services, video editing, lehigh valley, chester
     county, kutztown, website builder, designer, wedding photography,
      family portraits, headshots, youtube editing, social media, 
      creative marketing" data-react-helmet="true"/>
      <meta name="robots" content="index, follow"/>
      <meta name="author" content="Mason Ayres"/>
      <meta name="copyright" content="Mason Ayres Creative, LLC"/>
      <meta property="og:title" content="Mason Ayres Creative | 
      Graphic Design, Photography & Videography" data-react-helmet="true"/>
      <meta property="og:description" content="Mason Ayres Creative offers 
      top-notch graphic design, photography, and videography services
       in Berks County and surrounding areas. Contact us for professional
        and creative solutions." data-react-helmet="true"/>
        <meta property="og:image" content="/images/public_site_img.png"
         data-react-helmet="true"/><meta property="og:url" 
         content="https://masonayres.design" data-react-helmet="true"/>
         <meta property="og:type" content="website"/><meta property="og:site_name"
          content="Mason Ayres Creative" data-react-helmet="true"/>
          <meta name="twitter:card" content="summary_large_image" 
          data-react-helmet="true"/><meta name="twitter:title"
           content="Mason Ayres Creative | Graphic Design, Photography &
            Videography" data-react-helmet="true"/>
            <meta name="twitter:description"
             content="Mason Ayres Creative provides creative solutions 
             including graphic design, photography,
              and videography in Berks County, PA."
               data-react-helmet="true"/>
               <meta name="twitter:image"
                content="https://masonayres.design/images/public_site_img.png" 
                data-react-helmet="true"/>
            <title>Mason Ayres Creative | Graphic Design, Photography & Videography</title>
            </Helmet>
      <NavBar />
      <h3 className="kicker">Looking for something unique?</h3>
      <h1> GRAPHIC DESIGN, PHOTOGRAPHY & VIDEOGRAPHY. OR <strong className="headerorange">WHATEVER.</strong></h1>
     <h2><span className="brand">YOUR BRAND</span></h2>
              <span className="identity">YOUR IDENTITY, IN A NUTSHELL.</span>
               <div className="descriptionSection">
              <p className="description">
                Whether it's the brand of a large business, a solo entrepreneur's startup, or a personal brand, Mason Ayres Creative can help you express your voice with graphic design for your brand/site, stellar photography, and expressive, unique videography.
              </p>
              <p className="descriptionSmall">
                If you're looking for someone to help you unravel the mysteries of creative work, stop here. Our goal is to give honest, truly helpful, assistance for you and your business, no matter what it may be.
              </p>
            </div>
                   <div className="OurServices">
            <h2>OUR SERVICES</h2>
            <div className="services">
              <ul>
                <li>Logo Design</li>
                <li>Business Card Design</li>
                <li>Web Design</li>
                <li>Brand Strategy</li>
                <li>T-shirt Design</li>
                <li>Menu Design</li>
                <li>Page Layout/Book Design</li>
              </ul>
              <ul>
                <li>Motion Design/Animated Graphics</li>
                <li>Video Editing</li>
                <li>Commercial Videography</li>
                <li>Interview Videography</li>
                <li>Event Videography</li>
                <li>Product Videography</li>
                <li>Social Media Content Production</li>
              </ul>
              <ul>
                <li>Portrait Photography</li>
                <li>Product Photography</li>
                <li>Event Photography</li>
                <li>Photo Editing</li>
                <li>Business Strategy</li>
                <li>SEO Optimization</li>
                <li>Web Hosting</li>
                <li>Web Maintenance</li>
              </ul>
            </div>
             <span>VIDEOGRAPHY & PHOTOGRAPHY</span>
          </div>
                    <h2 className="PhilHeader">MY PHILOSOPHY:</h2>
          <h2 className="ChaseHeader">CHASE ADVENTURE, CAPTURE THE STORY</h2>
  <p className="PhilBody">
              Theres a lot of moments to miss out there. My goal when it comes to photos/video is to capture the moment as it feels, not just as it looks. Seeking out opportunities to capture unique moments is what I gravitate towards.
            </p>
            <p>
              Visit the <Link to="/photography" target="_top">Photography Page</Link> to see more!
            </p>
    </div>
      {isVisible && (
        <div className={`loading-screen ${startFadeOut ? 'fade-out' : ''}`}>
          <lottie-player
            src={lottieLoadFile}
            background="transparent"
            speed="1"
            autoplay
            renderer="svg"
            preload
            onError={(e) => console.error('LoadingScreen: Lottie failed to load', e)}
            onLoad={() => console.log('LoadingScreen: Lottie animation loaded')}
          ></lottie-player>

        </div>
    
      )}
    </>
  );
};

export default LoadingScreen;